export default __webpack_public_path__ + "static/media/new.18da5ebc.png";